import axios from 'axios';
export const baseUrl = process.env.REACT_APP_BASE_URL;

const setHeaders = (requestType) => {
  const headers = {
    'Access-Control-Allow-Origin': '*',
    Accept: '*/*',
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_Apim_Subscription_Key,
    'Strict-Transport-Security': 'max-age=31536000',
  };

  const sessionData = sessionStorage.getItem('persist:session');

  if (sessionData) {
    try {
      const parsedData = JSON.parse(sessionData);
      const isRehydrated = parsedData._persist
        ? JSON.parse(parsedData._persist).rehydrated
        : false;

      if (isRehydrated && parsedData.accessToken) {
        const accessToken = JSON.parse(parsedData.accessToken);
        if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
      } else {
        console.warn('Redux Persist has not rehydrated yet.');
      }
    } catch (error) {
      console.error('Error parsing session data:', error);
    }
  }

  const correlationID = sessionStorage.getItem('correlationId');
  if (correlationID) headers['x-correlation-id'] = `${correlationID}`;

  switch (requestType) {
    case 'GET_BLOB':
      headers['Content-Type'] = 'application/json';
      headers['responseType'] = 'blob';
      break;
    case 'GET_BLOB_FILE':
      headers['Content-Type'] = 'plain/txt';
      headers['Content-Disposition'] = 'attachment';
      break;
    case 'multipart/form-data':
      headers['Content-Type'] = 'multipart/form-data';
      break;
    default:
      headers['Content-Type'] = 'application/json';
  }

  return headers;
};

const handleHttpResponse = async (response) => {
  const customResponse = {
    statusCode: response.status || 0,
  };

  if (response.status >= 100 && response.status < 400) {
    customResponse.data = response.data || { message: 'Data not received' };
  } else if (response.status === 401) {
    sessionStorage.clear();
    window.location.href = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI;
  } else if (response.status >= 400 && response.status < 600) {
    customResponse.data = {
      message: response.data || 'Data not received',
    };
  } else {
    // Handle other cases as needed
  }

  return customResponse;
};

const handleHttpErrorResponse = async (response) => {
  const customResponse = {
    statusCode: response?.status || 0,
  };

  if (response.status >= 100 && response.status < 400) {
    customResponse.data = response.data || { message: 'Data not received' };
  } else if (response.status === 401) {
    sessionStorage.clear();
    window.location.href = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI;
  } else if (response.status >= 400 && response.status < 600) {
    customResponse.data = {
      message: response?.data?.title || 'The title key is missing from the response.',
    };
  } else {
    // Handle other cases as needed
  }
  return customResponse;
};

const apiWrapper = {
  getRequest: async (url, contentType = '', responseType = '') => {
    const headers = setHeaders(contentType);
    const options = { headers, responseType };

    try {
      const response = await axios.get(`${baseUrl}/${url}`, options);
      return await handleHttpResponse(response);
    } catch (error) {
      return await handleHttpErrorResponse(error.response);
    }
  },

  postRequest: async (url, data, contentType = '') => {
    const headers = setHeaders(contentType);
    const options = { headers };

    try {
      const response = await axios.post(`${baseUrl}/${url}`, data, options);
      return await handleHttpResponse(response);
    } catch (error) {
      console.error(error);
      return await handleHttpErrorResponse(error.response);
    }
  },
};

export default apiWrapper;
